<script setup>
    import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableSingle from "@/Components/TableSingle.vue";
    import { stringLiteralTypeAnnotation } from '@babel/types';
    defineProps({
        distritos: Array,
    });

    const rutaPrefijo = ref('distrito');
</script>

<template>
    <Head title="Config. Distritos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Distritos" />
        </template>

        <div class="py-8 lg:py-10">
            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <CardBox class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <TableSingle :data="distritos" :ruta="rutaPrefijo"/>
                        </CardBox>
                        
                        <!--
                        <CardBox v-if="distritos.length" class="mb-6" has-table>
                     
                            <TableSingle :data="distritos" :ruta="rutaPrefijo"/>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                        -->
                    </div>
                </div>
            
        </div>
    </BreezeAuthenticatedLayout>
</template>
